import {defineNuxtRouteMiddleware} from '#app';
import {safelyNavigateTo} from '@malt/utils';

export default defineNuxtRouteMiddleware((to) => {
    const {p, ...otherParams} = to.query;
    if (p === '1') {
        return safelyNavigateTo(
            {
                path: to.path,
                query: otherParams,
            },
            {redirectCode: 301},
        );
    }
});
